<template>
  <div :class="['row mx-0', addContainerClasses]">
    <div class="col-12 col-md-4 col-xl-3 pb-3 font-weight-bold pt-2" v-html="title"></div>
    <div class="col-12 col-md-8 col-xl-9">
        <button type="button"
        v-for="(item, index) in items"
        :key="index"
        :class="['btn btn-sm btn-outline-filter', filterUiState('fireBehavior', item.value)]"
        v-on:click="selectValue(item.value)">{{ item.title }}</button>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import { trackCallstack } from '../../../helper/tracker'

export default {
  name: 'StoCscFilterSectionFireBehavior',
  props: {
    addContainerClasses: String
  },
  data: function () {
    return {
      title: 'Brandverhalten',
      items: [
        { title: 'nichtbrennbar (A2-s1, d0)', value: 'A1A2' },
        { title: 'schwerentflammbar (B1)', value: 'B1' },
        { title: 'normalentflammbar (B2)', value: 'B2' },
        //{ title: 'leichtentflammbar (B3)', value: 'B3' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      filterUiState: 'filter/uiState',
      filterState: 'filter/state'
    })
  },
  methods: {
    selectValue: function (value) {
      let title = ''
      const result = this.items.filter(item => item.value === value)
      if (result.length > 0) title = result[0].title

      const uiState = this.filterUiState('fireBehavior', value)

      this.$gtm.trackEvent({
        event: 'filter',
        category: this.title.split('&shy;').join(''),
        action: uiState === 'pending' ? 'hinzufügen' : (uiState === 'active' ? 'reaktivieren' : 'aktivieren'),
        label: title,
        value: null
      })

      this.$store.dispatch('filter/setValue', {
        name: 'fireBehavior',
        title: this.title + ' ' + title,
        value: value
      }).then(() => trackCallstack(this.$gtm, this.filterState._callstack))
    }
  }
}

</script>
